import React, { useCallback, useEffect, useState } from 'react'

import axios from 'axios'
import { useLocation } from 'react-router-dom'
import { PartnerRequestModel } from './PartnerRequestModel'
import PartnerForm from './PartnerForm/PartnerForm'
import Rgpd from './Rgpd/Rgpd'
import ResultBlock from './ResultBlock/ResultBlock'
import { FormWrapper, ResultWrapper, Wrapper } from './FormContainer.style'

const API_URL = '/ser/api/Partner/nextories'

const FormContainer = () => {
  const location = useLocation()

  const [urlSearchParams, setUrlSearchParams] = useState({ utm_medium: '' })
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [requestDone, setRequestDone] = useState(false)
  const [requestSuccess, setRequestSuccess] = useState(false)
  const [errorCode, setErrorCode] = useState('')

  useEffect(
    () => {
      const searchParams = new URLSearchParams(location.search)
      setUrlSearchParams({
        utm_medium: searchParams.get('utm_medium') || searchParams.get('m'),
      })
    },
    [location],
  )

  const handleSubmit = useCallback(
    formData => {
      const requestData = PartnerRequestModel(formData, urlSearchParams)

      setIsSubmitting(true)

      axios
        .post(API_URL, requestData)
        .then(() => {
          setRequestSuccess(true)
        })
        .catch(({ response: { data } }) => {
          setRequestSuccess(false)
          setErrorCode(data.errorCode)
        })
        .finally(() => {
          setIsSubmitting(false)
          setRequestDone(true)
        })
    },
    [urlSearchParams, setErrorCode],
  )

  return (
    <Wrapper>
      <FormWrapper requestDone={requestDone}>
        <PartnerForm onSubmit={handleSubmit} isSubmitting={isSubmitting} />
        <Rgpd />
      </FormWrapper>

      {requestDone && requestSuccess && (
        <ResultWrapper>
          <ResultBlock />
        </ResultWrapper>
      )}
      {requestDone && !requestSuccess && (
        <ResultWrapper>
          <ResultBlock error errorCode={errorCode} />
        </ResultWrapper>
      )}
    </Wrapper>
  )
}

export default FormContainer
